import type { Location } from 'react-router-dom';

import { GUIDE_PATH } from './guideUrls';

type ReturnLocation = Pick<Location<unknown>, 'pathname' | 'search' | 'hash' | 'state'>;

/** Router state follows same-tab navigation, but is absent from copied/new-tab URLs. */
export function guideEntryState(location: Location<unknown>) {
  return { guideReturnTo: location };
}

export function guideReturnLocation(state: unknown): ReturnLocation | undefined {
  if (!state || typeof state !== 'object' || !('guideReturnTo' in state)) return;
  const target = state.guideReturnTo;
  if (!target || typeof target !== 'object') return;
  if (
    !('pathname' in target) ||
    typeof target.pathname !== 'string' ||
    !/^\/(?!\/)[^?#\\\s]*$/.test(target.pathname) ||
    target.pathname === GUIDE_PATH ||
    target.pathname.startsWith(`${GUIDE_PATH}/`) ||
    !('search' in target) ||
    typeof target.search !== 'string' ||
    !('hash' in target) ||
    typeof target.hash !== 'string'
  )
    return;
  return {
    pathname: target.pathname,
    search: target.search,
    hash: target.hash,
    state: 'state' in target ? target.state : null,
  };
}
